import {
  WebsiteButtonTypes,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { useThemeColor } from '.'
import { buttonAndFormFieldColorKeyMap } from 'src/editor/store/website-settings/website-settings-selector'

export const useSelectedButtonColor = (
  buttonType: WebsiteButtonTypes = WebsiteSettingsTypographyTypeEnum.PrimaryButton,
) => {
  const { buttons } = useThemeColor()
  const keys = buttonAndFormFieldColorKeyMap[buttonType]
  return {
    buttonTextColor: buttons?.[keys.textColor as keyof typeof buttons] || '',
    buttonBackgroundColor:
      buttons?.[keys.backgroundColor as keyof typeof buttons] || '',
    hoveredButtonBackgroundColor:
      buttons?.[keys.hoveredBackgroundColor as keyof typeof buttons] || '',
    pressedButtonBackgroundColor:
      buttons?.[keys.pressedBackgroundColor as keyof typeof buttons] || '',
    buttonBorderColor:
      buttons?.[keys.borderColor as keyof typeof buttons] || '',
  }
}
